import Proxies from '../components/proxies'
const { GET } = Proxies

export async function getPowerBiEmbedToken(reportId, workspaceId) {
  const response = await GET('powerbi/getPowerBIToken', {
    reportId,
    workspaceId
  })
  return response.token
}
